import {
  Avatar,
  Table,
  TableColumnType,
  TextHeader,
} from '@eltoro-ui/components'
import { usePagination } from '@eltoro-ui/hooks'
import { V1OrgData } from 'next-gen-sdk'
import { TablePagination } from 'Components'

const searchOrgTableColumns: TableColumnType<V1OrgData>[] = [
  {
    path: 'name',
    label: 'Name',
    filterOn: 'string',
    RowCell: (org) => (
      <div className="SearchOrgTable__name-row flex max-w-md items-center gap-2 p-1">
        {(() => {
          if (org.logo) {
            return <Avatar src={org.logo} rounded />
          }
          return <Avatar name={org.name || ''} rounded />
        })()}
        {org.name}
      </div>
    ),
  },
  {
    path: 'orgId',
    label: 'ID',
    removeFilter: true,
  },
]

export const SearchOrgTable: React.FC<{
  results: V1OrgData[]
  handleRowClick: (clicked: V1OrgData) => void
}> = ({ results, handleRowClick }) => {
  const orgPagination = usePagination<V1OrgData>({
    pageSize: 5,
    sourceData: results,
  })

  if (!results.length) return null

  return (
    <div className="SearchCreativeTable">
      <TextHeader type={4} className="SearchCreativeTable__header mt-4">
        Orgs ({results.length})
      </TextHeader>
      <div className="p-4">
        {orgPagination.data && (
          <>
            <Table
              columns={searchOrgTableColumns}
              rows={orgPagination.data}
              onClick={(org) => handleRowClick(org)}
            />

            <div className="flex justify-end pt-2">
              <TablePagination pagination={orgPagination} />
            </div>
          </>
        )}
      </div>
    </div>
  )
}
